import { MapPin, PhoneCall } from "lucide-react";
import { Reveal } from "./motion";
import { REGIONS, BUSINESS } from "@/data/siteData";

export default function Areas() {
  return (
    <section id="areas" data-testid="areas-section" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto">
            <p className="text-brand font-semibold text-sm tracking-wide uppercase">Areas We Serve</p>
            <h2 className="font-display font-bold text-ink tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.1]">
              Serving Southern California
            </h2>
            <p className="text-slate2 text-base sm:text-lg mt-4">
              Proudly covering Orange County, the greater Los Angeles area, and the Inland Empire. Don't see your city? Just call — we likely cover it.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-5 lg:gap-6">
          {REGIONS.map((region, ri) => (
            <Reveal key={region.name} delay={ri * 0.08}>
              <div data-testid={`region-${ri}`} className="card-soft hover:!translate-y-0 h-full p-7 lg:p-8">
                <div className="flex items-center gap-3">
                  <span className="h-11 w-11 rounded-xl bg-brand/10 text-brand flex items-center justify-center">
                    <MapPin size={20} />
                  </span>
                  <h3 className="font-display font-semibold text-ink text-xl">{region.name}</h3>
                </div>
                <div className="mt-6 flex flex-wrap gap-2">
                  {region.cities.map((city) => (
                    <span key={city} className="inline-flex items-center rounded-full bg-mist border border-gray-100 text-slate2 text-sm px-3 py-1.5">
                      {city}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href={BUSINESS.phoneHref} data-testid="areas-call" className="btn-accent rounded-full px-7 py-3.5 text-sm font-semibold flex items-center gap-2">
              <PhoneCall size={16} /> Call to Confirm Your Area
            </a>
            <span className="text-slate2 text-sm">Mobile service priced by distance — {BUSINESS.phone}</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
